/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineParseResponse {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineParseResponse.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineParseResponse>): AIUnitEconomicsBaselineParseResponse {
        let obj = Object.assign(new AIUnitEconomicsBaselineParseResponse(), model);
        AIUnitEconomicsBaselineParseResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineParseResponse>): AIUnitEconomicsBaselineParseResponse {
        if (!model) return null;
        return AIUnitEconomicsBaselineParseResponse.newInstance(<AIUnitEconomicsBaselineParseResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineParseResponse) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineParseResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineParseResponse): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineParseResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.row_count === undefined) {
            this.row_count = 0;
        }
        if (this.unique_key_count === undefined) {
            this.unique_key_count = 0;
        }
        if (this.configuration) {
            for (let val of this.configuration) {
                models.AIUnitEconomicsBaselineConfigurationEntry.fixupPrototype(val);
            }
        }
        if (this.errors) {
            for (let val of this.errors) {
                models.AIUnitEconomicsBaselineParseIssue.fixupPrototype(val);
            }
        }
        if (this.warnings) {
            for (let val of this.warnings) {
                models.AIUnitEconomicsBaselineParseIssue.fixupPrototype(val);
            }
        }
    }

    /**
     * Field used to identify entries
     */
    primary_key: string;

    /**
     * Column headers found in the file
     */
    detected_columns: Array<string>;

    /**
     * Parsed entries, ready to submit to the create endpoint once any errors are resolved
     */
    configuration: Array<models.AIUnitEconomicsBaselineConfigurationEntry>;

    /**
     * Number of entries parsed
     */
    row_count: number;

    /**
     * Number of distinct primary key values parsed
     */
    unique_key_count: number;

    /**
     * Row problems that must be fixed before the baseline can be created
     */
    errors: Array<models.AIUnitEconomicsBaselineParseIssue>;

    /**
     * Row observations that do not block creation, such as unmeasured quality scores
     */
    warnings: Array<models.AIUnitEconomicsBaselineParseIssue>;

}
